import editorConfig from '~config/editorConfig';
import { getState, getStatePure, modifyState, unsetState } from '~src/state';
import _ from 'lodash';
import { triggerStateChangedRequest } from '~core';

function difference(object, base) {
  function changes(object, base) {
    return _.transform(object, function (result, value, key) {
      if (!_.isEqual(value, base[key])) {
        result[key] =
          _.isObject(value) && _.isObject(base[key])
            ? changes(value, base[key])
            : value;
      }
    });
  }
  return changes(object, base);
}

const animatedProps = [
  'angle',
  'top',
  'left',
  'width',
  'height',
  'scaleX',
  'scaleY',
  'opacity',
];

export const onStartAnimation = () => {
  modifyState('preventSidebarToggle', true);
  const activeObject = window.canvas.getActiveObject();

  if (activeObject.type === 'activeSelection') {
    modifyState('pendingAnimation', {});
    return;
  }

  if (!activeObject) {
    alert("Seleziona l'oggetto che vuoi animare");
  }

  const { objRefId } = activeObject.giotto;

  //   const animations = getStatePure('animations', []);
  const pendingAnimation = getStatePure('pendingAnimation');

  const currentProps = {};
  for (const animatedProp of animatedProps) {
    if (activeObject.get(animatedProp)) {
      currentProps[animatedProp] = activeObject.get(animatedProp);
    }
  }

  if (!pendingAnimation) {
    const pendingAnimation = {
      objects: [objRefId],
      _fromProps: _.clone(currentProps),
    };

    modifyState('pendingAnimation', pendingAnimation);

    activeObject.clone((cloned) => {
      window.canvas.discardActiveObject();
      activeObject.set({
        opacity: 0.1,
      });
      cloned.set({
        top: cloned.top,
        evented: true,
        giotto: {
          objRefId,
          animationParent: activeObject,
        },
      });
      window.canvas.add(cloned);
      window.canvas.setActiveObject(cloned);
      window.canvas.requestRenderAll();
    }, editorConfig.additionalJsonProperties);
  } else {
    const diffProps = difference(pendingAnimation._fromProps, currentProps);
    const diffKeys = Object.keys(diffProps);
    pendingAnimation.fromProps = {};
    pendingAnimation.toProps = {
      duration: 5,
      ease: 'Linear',
      title: 'Personalizzata',
    };

    for (const diffKey of diffKeys) {
      pendingAnimation.fromProps[diffKey] =
        pendingAnimation._fromProps[diffKey];
      pendingAnimation.toProps[diffKey] = currentProps[diffKey];
    }

    delete pendingAnimation._fromProps;
    const pages = getStatePure('pages');
    const currentPageIndex = getState('currentPageIndex');
    if (!pages[currentPageIndex].animations) {
      pages[currentPageIndex].animations = [];
    }
    pages[currentPageIndex].animations.push(pendingAnimation);
    modifyState('pages', pages);
    unsetState('pendingAnimation');

    activeObject.giotto.animationParent.set({
      opacity: 1,
    });
    window.canvas.remove(activeObject);
    window.canvas.renderAll();
    triggerStateChangedRequest();
  }
};
